import React from 'react'
import EmptySpace from './EmptySpace'

const BlackquoteHomepage = () => (
  <div>
    <blockquote
      className="type4"
      style={{
        backgroundColor: '#e91e63',
      }}
    >
      <h3>
        Zabawa jest radością
      </h3>
      <q>
        Dziecko, bawiąc się, doznaje po raz pierwszy w życiu radości twórcy i władcy.
      </q>
      <cite>
        – Antoni Kępiński
      </cite>
    </blockquote>
    <EmptySpace />
    <blockquote
      className="type4"
      style={{
        backgroundColor: '#ff5722',
      }}
    >
      <h3>
        Uwidoczniona miłość
      </h3>
      <q>
        Dziecko jest chodzącym cudem, jedynym, wyjątkowym i niezastąpionym.
      </q>
      <cite>
        – Phil Bosmans
      </cite>
    </blockquote>
    <EmptySpace />
    <blockquote
      className="type4"
      style={{
        backgroundColor: '#673ab7',
      }}
    >
      <h3>
      Przyswajanie wiedzy
      </h3>
      <q>
      Dziecko może nauczyć dorosłych trzech rzeczy: cieszyć się bez powodu, być ciągle czymś zajętym i domagać się swoich pragnień.
      </q>
      <cite>
      – Paulo Coelho
      </cite>
    </blockquote>
    <EmptySpace />
  </div>
)

export default BlackquoteHomepage
